import { render, staticRenderFns } from "./_part_parent_address.vue?vue&type=template&id=66faa829&lang=pug"
import script from "./_part_parent_address.vue?vue&type=script&lang=js"
export * from "./_part_parent_address.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports